document.addEventListener('variant:change', function(event) {

  const dataElement = document.querySelector('[data-product-variant-meta]');

  if (!dataElement) return;

  const variantData = JSON.parse(dataElement.textContent);
  const variantId = event.detail.variant.id;

  if (!variantData[variantId]) return;

  const subtitle = document.querySelector('[data-variant-subtitle]');

  if (subtitle && variantData[variantId].subtitle !== undefined) {
    subtitle.innerHTML = variantData[variantId].subtitle;
  }

  const specs = document.querySelector('[data-variant-specifications]');

  if (specs && variantData[variantId].specs !== undefined) {
    specs.innerHTML = variantData[variantId].specs;
  }

});